import { render } from "./payment-options.vue?vue&type=template&id=6bfaf304&scoped=true&ts=true"
import script from "./payment-options.vue?vue&type=script&lang=ts"
export * from "./payment-options.vue?vue&type=script&lang=ts"

import "./payment-options.vue?vue&type=style&index=0&id=6bfaf304&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bfaf304"]])

export default __exports__